import React from 'react';
import { Hero } from './components/Hero';
import { ProofBar } from './components/ProofBar';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { WhatYouGet } from './components/WhatYouGet';
import { Gallery } from './components/Gallery';
import { Comparison } from './components/Comparison';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { PurchaseToast } from './components/PurchaseToast';
import { useMetaPixel } from './hooks/useMetaPixel';
interface AppProps {
  showUrgency?: boolean;
  showPurchaseNotifications?: boolean;
}
export function App({
  showUrgency = true,
  showPurchaseNotifications = true
}: AppProps) {
  useMetaPixel();
  return <div className="w-full bg-white" data-id="element-0" data-mp="3ikh8ubu2yx01">
      <main data-id="element-1" data-mp="3ijfx0558q6h9">
        <Hero data-id="element-2" data-mp="3ijpe138b53at" />
        <ProofBar data-id="element-3" data-mp="3ii4s22026sok" />
        <Problem data-id="element-4" data-mp="3mlaxx8j9ehui" />
        <Gallery data-id="element-5" data-mp="3mkrbpfmkt7ao" />
        <Solution data-id="element-6" data-mp="3mk852v2dm5by" />
        <WhatYouGet data-id="element-7" data-mp="3mjq3diwy2ywn" />
        <Comparison data-id="element-8" data-mp="3mj6lg27aoaim" />
        <Bonuses data-id="element-9" data-mp="3rbr9so7flver" />
        <Pricing showUrgency={showUrgency} data-id="element-10" data-mp="3rdaquh0wwahl" />
        <Testimonials data-id="element-11" data-mp="3recctgjguhe3" />
        <Guarantee data-id="element-12" data-mp="5otf64sd496" />
        <Faq data-id="element-13" data-mp="680tswt8a8y" />
        <FinalCta showUrgency={showUrgency} data-id="element-14" data-mp="4n4bxqxqh8g" />
      </main>
      <Footer data-id="element-15" data-mp="2zl3dbpgpde7f" />
      {showPurchaseNotifications && <PurchaseToast data-id="element-16" data-mp="2zmenc70qri6z" />}
    </div>;
}